import { render, staticRenderFns } from "./BindingDevice.vue?vue&type=template&id=68bfde29&"
import script from "./BindingDevice.vue?vue&type=script&lang=js&"
export * from "./BindingDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports